<template>
  <div class="inicioInterativo">
      <i class="fas fa-house-user inicioInterativoIcone"></i>
  </div>
</template>

<script>
export default {
    name: 'inicioInterativo',
}
</script>

<style>
.inicioInterativo {
    position: relative;
    height: 50px;
    width: 50px;
}
.inicioInterativo:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
}
.inicioInterativoIcone {
    position: absolute;
    top: 13px;
    left: 12px;
    font-size:  25px;
    color: #008fac;
}
</style>